import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi2";

/**
 * Compact pagination footer used inside dashboard cards.
 *
 * Props:
 * - page: current page (1-based)
 * - totalPages: total number of pages
 * - totalItems: total item count (for the range label)
 * - pageSize: items per page (for the range label)
 * - onPageChange: (newPage) => void
 * - className: optional wrapper override
 */
const Pagination = ({
  page,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  className = "",
}) => {
  if (totalPages <= 1) return null;

  const startIdx = (page - 1) * pageSize;
  const endIdx = Math.min(startIdx + pageSize, totalItems);
  const canPrev = page > 1;
  const canNext = page < totalPages;

  const buttonClass =
    "inline-flex items-center justify-center w-7 h-7 rounded-md text-grey hover:bg-surface-hover disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent";

  return (
    <div
      className={`flex items-center justify-between pt-3 mt-3 ${className}`.trim()}
    >
      <span className="text-xs text-mediumgrey tabular-nums">
        {startIdx + 1}–{endIdx} of {totalItems}
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={!canPrev}
          className={buttonClass}
          aria-label="Previous page"
        >
          <HiOutlineChevronLeft className="w-3.5 h-3.5" />
        </button>
        <span className="text-xs text-grey px-2 tabular-nums">
          {page}/{totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={!canNext}
          className={buttonClass}
          aria-label="Next page"
        >
          <HiOutlineChevronRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
